<template>
  <div style="margin: 0 24px 8px;">
    <el-form ref="formRef" :model="purchaseForm" label-width="auto" label-position="right">
      <el-form-item label="">
        <el-button v-if="idx == -1" @click="chooseCommodity">选择商品</el-button>

        <div class="user-list-item" v-if="JSON.stringify(commodityForm) != '{}'">
          <div class="item-img">
            <div v-if="commodityForm.commodityImgList.length > 0" class="item-img cursor"  @click="userImgList(commodityForm)">
              <el-image class="item-img" fit="cover" :src="commodityForm.commodityImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </div>
          <div class="text-list">
            <div class="text-list-item" style="width: 60%;">
<!--              <label></label>-->
              <span style="white-space: nowrap; overflow:hidden; text-overflow: ellipsis">商品名称：{{commodityForm.name}}</span>
            </div>
            <div class="text-list-item" style="width: 40%">
<!--              <label></label>-->
              <span>计量单位：{{commodityForm.measureUnitName}}</span>
            </div>
            <div class="text-list-item" style="width: 60%">
<!--              <label></label>-->
              <span>供货商：{{commodityForm.supplierName}}</span>
            </div>
            <div class="text-list-item" style="width: 40%">
<!--              <label></label>-->
              <span>进货单价：{{commodityForm.price}}</span>
            </div>
            <div class="text-list-item" style="width: 60%">
<!--              <label></label>-->
              <span>商品品牌：{{commodityForm.brandName}}</span>
            </div>
            <div class="text-list-item" style="width: 40%">
<!--              <label></label>-->
              <span>建议零售价：{{commodityForm.retailPrice}}</span>
            </div>
            <div class="text-list-item" style="width: 60%">
<!--              <label></label>-->
              <span>商品规格：{{commodityForm.specification}}</span>
            </div>
          </div>
        </div>

      </el-form-item>
      <el-form-item label="所属门店：">
        <el-select v-model="shopId" placeholder="Select" class="select-item" disabled>
          <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="采购数量：">
        <el-input v-model="purchaseForm.num" placeholder="请输入数值"  :disabled="purchaseForm.state == 3"/>
      </el-form-item>
      <el-form-item label="赠送数量：">
        <el-input v-model="purchaseForm.giveNum" placeholder="请输入数值"  :disabled="purchaseForm.state == 3"/>
      </el-form-item>
      <el-form-item label="优惠金额：">
        <el-input v-model="purchaseForm.reduceMoney" placeholder="请输入优惠金额"  :disabled="purchaseForm.state == 3"/>
      </el-form-item>
      <el-form-item label="关联批次号：" v-if="purchaseForm.state == 1 || purchaseForm.state == 2 || purchaseForm.state == 3">
        <el-input v-model="purchaseForm.numberNo" placeholder="请输入数值"  :disabled="purchaseForm.state == 3"/>
      </el-form-item>
      <el-form-item label="驳回原因：" v-if="commodityForm.state == 2">
        <span style="color: red">{{commodityForm.refusalReason}}</span>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdatePurchaseCommodity } from "@/api/url";
import { phoneReg, positiveIntReg } from "@/assets/shared/reg-constant";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import CommodityList from "@/views/commodity/components/CommodityList";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      purchaseForm: this.value.purchaseForm,
      idx: this.value.ids,
      shopId: this.value.shopId,
      shopIdArray: [],
      commodityForm: {},
    }
  },
  methods: {

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.commodityImgList,
          id: row.commodityId,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    chooseCommodity() {
      let _title = '';
      _title = '商品列表'
      Drawer.open({
        title: _title,
        component: CommodityList,
        data: {
          width: 800,
          from: 1,
        },
        confirm: (result) => {
          this.commodityForm = result
        }
      })
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      console.log(this.idx)
      if(JSON.stringify(this.commodityForm) == '{}') {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择商品',
          type: 'warning'
        });
        return false
      }
      if(!positiveIntReg.test(this.purchaseForm.num)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '采购数量不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.purchaseForm.id:0;
      param['shopId'] = this.shopId;
      param['commodityId'] = this.idx > -1?this.purchaseForm.commodityId:this.commodityForm.id;
      param['supplierId'] = this.commodityForm.supplierId;
      param['brandId'] = this.commodityForm.brandId;
      param['price'] = this.commodityForm.price;
      param['num'] = this.purchaseForm.num;
      param['giveNum'] = this.purchaseForm.giveNum?this.purchaseForm.giveNum:0;
      param['reduceMoney'] = this.purchaseForm.reduceMoney?this.purchaseForm.reduceMoney:0;
      param['numberNo'] = this.purchaseForm.numberNo;
      postFormData(addOrUpdatePurchaseCommodity, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

  },
  mounted() {
    if(this.idx > -1) {
      this.commodityForm = this.purchaseForm
      this.commodityForm.name = this.purchaseForm.commodityName
    }
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
  }
}
</script>

<style scoped>

.user-list-item {
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-top: 12px;
  /*background-color: #f6f6f6;*/
  display: flex;
  align-items: center;
  /*cursor: pointer;*/
  width: 100%;
}

.input-item label {
  margin-right: 8px;
}

.item-img {
  width: 90px;
  height: 90px;
}

.text-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: 16px;
  width: 100%;
  /*margin-top: 6px;*/
}

.text-list-item {
  /*width: 50%;*/
  margin: 1px 0;
  display: flex;
  align-items: center;
  line-height: 1.4;
  /*font-size: 13px;*/
}

.text-list-item label {
  /*width: 84px;*/
}
</style>
